module.exports = __webpack_public_path__ + "static/media/GreenTea – 1.25411a01.jpg";